import {useMutation} from '@tanstack/vue-query';
import { getApi } from '../api';

export default () => useMutation({
    mutationFn: ({ dialogId, message, model, files, user_id } : { dialogId: number, message: string, model: string, files?: any, user_id?: number }) => {
        const { api, baseURL } = getApi();
        const payload: any = { message, model };
        if (files && files.length > 0) {
            payload.files = files;
        }
        if (user_id) {
            payload.user_id = user_id;
        }
        return (api as any).post(`/api/v2/dialogs/${dialogId}/messages`, payload, { baseURL, useOriginalToken: true }).then(res => res.data.data)
    },
})
